import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref } from "vue";
import { validateEmail, validateMobile } from "@/utils/validate";
import { httpPost } from "@/utils/http";
import { ElMessage } from "element-plus";
import Captcha from "@/components/Captcha.vue";
import { getSystemInfo } from "@/store/cache";
import { useRouter } from "vue-router";
import * as authUtil from '@/utils/auth';
export default /*@__PURE__*/_defineComponent({
  __name: 'SendMsg',
  props: {
    receiver: String,
    scene: Number,
    size: String,
    type: {
      type: String,
      default: "mobile"
    }
  },
  setup(__props) {
    // 发送短信验证码组件
    const router = useRouter();
    // eslint-disable-next-line no-undef
    const props = __props;
    const btnText = ref("发送验证码");
    const canSend = ref(true);
    const captchaRef = ref();
    const enableVerify = ref(false);
    const userType = router.currentRoute.value.query["type"];
    getSystemInfo().then(res => {
      enableVerify.value = res.data["enabled_verify"];
    });
    // 获取租户 ID
    const loadTenantId = async () => {
      if (userType === 'enterprise') {
        // const res = await LoginApi.getTenantIdByCode(form.value.tenantCode)
        // if (!res) {
        //   showMessageInfo("租户编码不存在！");
        //   return false
        // }
        // authUtil.setTenantId(res)
      } else {
        authUtil.setTenantId(1);
      }
      return true;
    };
    const sendMsg = async () => {
      if (!validateMobile(props.receiver) && props.type === "mobile") {
        return ElMessage.error("请输入合法的手机号");
      }
      if (!validateEmail(props.receiver) && props.type === "email") {
        return ElMessage.error("请输入合法的邮箱地址");
      }
      if (enableVerify.value) {
        captchaRef.value.loadCaptcha();
      } else {
        doSendMsg({});
      }
    };
    const doSendMsg = async data => {
      if (!canSend.value) {
        return;
      }
      // 加载租户ID
      await loadTenantId();
      canSend.value = false;
      httpPost("/system/auth/send-sms-code", {
        // receiver: props.receiver,
        // key: data.key,
        // dots: data.dots,
        // x: data.x,
        mobile: props.receiver,
        scene: props.scene
      }).then(() => {
        ElMessage.success("验证码发送成功");
        let time = 60;
        btnText.value = time + 's';
        const handler = setInterval(() => {
          time = time - 1;
          if (time <= 0) {
            clearInterval(handler);
            btnText.value = "重新发送";
            canSend.value = true;
          } else {
            btnText.value = time + 's';
          }
        }, 1000);
      }).catch(e => {
        canSend.value = true;
        ElMessage.error("验证码发送失败：" + e.message);
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: "send-verify-code"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "success",
          size: props.size,
          disabled: !canSend.value,
          onClick: sendMsg
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(btnText.value), 1)]),
          _: 1
        }, 8, ["size", "disabled"]), _createVNode(Captcha, {
          onSuccess: doSendMsg,
          ref_key: "captchaRef",
          ref: captchaRef
        }, null, 512)]),
        _: 1
      });
    };
  }
});